import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// --- Error Suppression for ResizeObserver ---
const RESIZE_OBSERVER_ERRORS = ["ResizeObserver loop completed with undelivered notifications.", "ResizeObserver loop limit exceeded",];

window.addEventListener("error", (e) => {
  if (RESIZE_OBSERVER_ERRORS.includes(e.message)) { e.stopImmediatePropagation(); }
});

window.addEventListener("unhandledrejection", (e) => {
  const reason = (e as PromiseRejectionEvent).reason;
  if (reason?.message && RESIZE_OBSERVER_ERRORS.includes(reason.message)) { e.preventDefault(); }
});

// Optional: Hide noisy ResizeObserver console warnings
const originalError = console.error;
console.error = (...args: any[]) => {
  if (typeof args[0] === "string" && args[0].includes("ResizeObserver loop limit exceeded")) { return; }
  originalError(...args);
};

// --- App Rendering ---

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<App />);

// Initialize performance monitoring
reportWebVitals();
